import Dropdown from "components/inputs/dropdown";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import Graph from "./components/graph";
import { GraphData } from "./components/graph/placeholderdata";
import GraphLabelFilter from "./components/graphLabelFilter";

const Statistics = () => {
  const [activeLabels, setActiveLabels] = useState([
    "Spotify",
    "Apple Music",
    "Deezer",
    "Amazon",
    "Youtube"
  ]);

  const [timeFilter, setTimeFilter] = useState("Last Year");

  const dropdownList = [
    "Last 24 hours",
    "Last 7 days",
    "Last month",
    "Last 3 months",
    "Last 6 months",
    "Last Year"
  ];

  const data = useMemo(() => {
    const newData = GraphData.filter((data) =>
      activeLabels.includes(data.label)
    );
    return newData;
  }, [activeLabels]);

  return (
    <Container>
      <DropdownContainer>
        <Dropdown
          chosenItem={timeFilter}
          items={dropdownList}
          selectItem={(val) => {
            setTimeFilter(val);
          }}
        />
      </DropdownContainer>
      <GraphContainer>
        <Graph data={data} />
      </GraphContainer>

      <GraphLabelFilter
        data={activeLabels}
        setData={(data) => setActiveLabels(data)}
      />
    </Container>
  );
};

export default Statistics;

const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 2.4rem 6rem;
  @media only screen and (max-width: 769px) {
    padding: 2.4rem;
  }
`;

const DropdownContainer = styled.div`
  display: flex;
  width: fit-content;
  min-width: 12rem;
  margin-left: auto;
  margin-bottom: 2.5rem;
`;

const GraphContainer = styled.div`
  width: 100%;
  height: 30rem;
  margin-bottom: 3rem;
`;
